import clsx from 'clsx';
import React from 'react';

import { CommentUser } from '../../../../utils/backend-api/comments';
import TopicPostAuthor from '../TopicPostAuthor';
import styles from './styles.module.scss';

interface TopicPostAuthorsProps {
  authors: CommentUser[];
}

export default function TopicPostAuthors({ authors }: TopicPostAuthorsProps) {
  return (
    <div className="topic-users">
      <div className="reporter-container row">
        <div className="col-xs-12">
          <span className="topic-users-heading">Popular Contributors</span>
        </div>
      </div>
      <div id="authors-avatars" className="row">
        <div className="col-xs-12">
          <div className={clsx(styles.bylineContainer)}>
            <div className={clsx(styles.byline)}>
              <div className={clsx(styles.bylineWrapper)}>
                {authors.map((author) => (
                  <TopicPostAuthor key={author.id} author={author} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
